import { derived, get, writable } from 'svelte/store';
import { isNonProductionAppBuild } from 'src/helpers/dev_tools';

const STORAGE_KEY = 'shelly_dev_device_table_view';

const readInitialValue = (): boolean => {
	if (!isNonProductionAppBuild()) return false;
	try {
		const stored = localStorage.getItem(STORAGE_KEY);
		if (stored === null) return true;
		return stored === 'true';
	} catch {
		return true;
	}
};

/**
 * Dev/staging prototype for the All Devices table layout.
 * Default on for non-production builds; always off in production.
 * Preference is local-only and can be toggled from the Dev Modal.
 */
export const deviceTableViewEnabled = writable<boolean>(readInitialValue());

deviceTableViewEnabled.subscribe((value) => {
	if (!isNonProductionAppBuild()) return;
	try {
		localStorage.setItem(STORAGE_KEY, String(value));
	} catch {
		// localStorage may be unavailable
	}
});

export const deviceTableViewAvailable = derived(
	deviceTableViewEnabled,
	($enabled) => isNonProductionAppBuild() && $enabled,
);

export const isDeviceTableViewAvailable = (): boolean => get(deviceTableViewAvailable);

export const setDeviceTableViewEnabled = (enabled: boolean) => {
	deviceTableViewEnabled.set(isNonProductionAppBuild() ? enabled : false);
};
